import { skipToken } from "@tanstack/react-query";
import { v2CustomDomainRouter } from "@trpc/v2CustomDomain";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";

const useDefaultV2CustomDomain = () => {
  const projectId = useCurrentProjectId();

  const { data: customDomainData } =
    v2CustomDomainRouter.getByProjectId.useQuery(
      projectId ? { projectId } : skipToken,
    );

  const defaultCustomDomain = customDomainData?.customDomains.find(
    (domain) => !domain.isPending,
  );

  return defaultCustomDomain;
};

export default useDefaultV2CustomDomain;
